<footer>
    <div class="green-container">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-3">
                    <div class="logo">
                        <a routerLink="/home" style="text-decoration: none; margin: 0;">
                            <img src="assets/images/logo_ZBE_WEB-01.svg" alt="logo">
                        </a>
                        <!-- <p i18n>Zona de Bajas Emisiones</p> -->
                    </div>
                </div>
            </div>
            <div class="row images">
                <div class="col-6 col-md-2"><img src="assets/images/logo-union-europea.jpeg" alt="Logo union europea"></div>
                <div class="col-6 col-md-2 gob_es"><img src="assets/images/gobierno_espana.svg" alt="Logo Gobierno españa"></div>
                <div class="col-6 col-md-2"><img src="assets/images/logo_prtr.png" alt="Logo PRTR"></div>
                <div class="col-6 col-md-2"></div>
                <div class="col-6 col-md-2"><img src="assets/images/next_gene.jpg" alt="Logo next generation"></div>
                <div class="col-6 col-md-2"><img src="assets/images/logo_gen.jpg" alt="Logo generalitat"></div>
            </div>
        </div>
    </div>
    <div class="black-container text-center">
        <div class="container">
            <p>© 2025 <span i18n>Todos los derechos reservados</span></p>
            <ul class="without-dot">
                <li><a routerLink="/cookies" i18n>Política de cookies</a></li>
                <!-- <li><a routerLink="/data-protection" i18n>Política de privacidad</a></li> -->
                <li><a routerLink="/use-conditions" i18n>Aviso legal</a></li>
                <li><a routerLink="/accesible" i18n>Accesibilidad</a></li>
            </ul>
        </div>
    </div>
</footer>